export type { MenuSplitGroupProps, MenuSplitGroupSlots, MenuSplitGroupState } from './components/MenuSplitGroup/index';
export {
  MenuSplitGroup,
  menuSplitGroupClassNames,
  renderMenuSplitGroup_unstable,
  useMenuSplitGroupStyles_unstable,
  useMenuSplitGroup_unstable,
} from './components/MenuSplitGroup/index';
